module.exports = "/assets/home-page/media/wyborcza.png?dFTvTxt";